/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function ($) {
  'use strict';
  
  /**
   * Вид для верхних растяжек категорий Промо.
   */
  app.CategoryPromoTopImageView = app.View.extend({
    el: '.promo_top_image',
    
    run: function () {
      if (!this.$('area').length) {
        return;
      }
      var that = this;
      this.imgMaxHeight = parseInt(this.$('img').css('max-height'));
      this.mapArea = [];
      _.each(this.$('area'), function (mapArea) {
        that.mapArea.push($(mapArea).attr('coords').split(','));
      });
      
      this.listenTo(app.mainWindow, 'window.resize', this.waitForNewPosition);
      if ((this.$('img').height() / this.imgMaxHeight) < 1) {
        this.setNewMapAreaPosition();
      }
    },
  
    /**
     * Устанавливает новую позицию для области кликов.
     */
    setNewMapAreaPosition: function () {
      var that = this,
        diff = app.helpers.NumberHelper.roundFloatPointNum(this.$('img').height() / this.imgMaxHeight);
      
      _.each(that.mapArea, function (coords, i) {
        var newCoords = coords.map(function (coord) {
          return Math.floor(coord * diff);
        });
        that.$('area').eq(i).attr('coords', newCoords);
      });
    },
  
    /**
     * Ждет окончания ресайза окна.
     */
    waitForNewPosition: function () {
      if (this.resizeTimer) {
        clearTimeout(this.resizeTimer);
      }
      this.resizeTimer = setTimeout(this.setNewMapAreaPosition.bind(this), 500);
    },
    
  });
})(jQuery);

}.call(window));